@if (zone && dataConfig) {
    <span class="icon-threedots"></span>

    <label class="item">{{ displayName }}</label>

    <div class="dropdown-wrapper">
        <span class="icon-arrow-down" (click)="showColumnFormatters(dataConfig, zone.id)"></span>
    </div>

    <span class="icon-close1" (click)="onRemove(dataConfig.colId)"></span>
}
